import { useState, useRef } from "react";
import emailjs from "@emailjs/browser";
import "../styles/ContactForm.css";
import politicas from "../assets/documents/politica-datos.pdf";

export default function ContactForm({ traducciones }) {
  const formRef = useRef();

  const [form, setForm] = useState({
    nombre: "",
    empresa: "",
    telefono: "",
    celular: "",
    email: "",
    asunto: "",
    mensaje: "",
    aceptaPolitica: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({
      ...form,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const camposVacios = Object.entries(form).some(([key, value]) => {
      if (key === "aceptaPolitica") return false;
      return value.trim() === "";
    });

    if (camposVacios || !form.aceptaPolitica) {
      alert("Por favor, complete todos los campos y acepte las condiciones.");
      return;
    }

    emailjs
      .sendForm(
        "service_4fo3hmn",
        "template_vcsg0gv",
        formRef.current,
        "2bID9DDqNB4hrIEjT"
      )
      .then(
        () => {
          alert("Mensaje enviado correctamente.");
          setForm({
            nombre: "",
            empresa: "",
            telefono: "",
            celular: "",
            email: "",
            asunto: "",
            mensaje: "",
            aceptaPolitica: false,
          });
        },
        (error) => {
          alert("Hubo un error al enviar el mensaje: " + error.text);
        }
      );
  };

  return (
    <div className="contact-form container">
      <p className="text">
      {traducciones.contacto
            ? traducciones.contacto.texto
            : ""}
      </p>
      <form ref={formRef} onSubmit={handleSubmit} className="row g-3">
        {["nombre", "empresa", "telefono", "celular", "email", "asunto"].map(
          (field, index) => (
            <div key={index} className="col-md-6">
              <input
                type={field.toLowerCase() === "email" ? "email" : "text"}
                name={field.toLowerCase()}
                className="form-control"
                placeholder={
                  traducciones.contacto ? traducciones.contacto[field] : field
                }
                value={form[field.toLowerCase()]}
                onChange={handleChange}
                required
              />
            </div>
          )
        )}
        <div className="col-12">
          <textarea
            name="mensaje"
            className="form-control"
            placeholder={
              traducciones.contacto ? traducciones.contacto.mensaje : "Mensaje"
            }
            value={form.mensaje}
            onChange={handleChange}
            rows="4"
            required
          ></textarea>
        </div>
        <div className="col-12">
          <label className="form-check-label d-flex align-items-center">
            <input
              type="checkbox"
              name="aceptaPolitica"
              className="form-check-input me-2"
              checked={form.aceptaPolitica}
              onChange={handleChange}
              required
            />
            <span>
              {traducciones?.contacto?.condiciones?.includes("Policy")
                ? traducciones.contacto.condiciones.split(
                    "Personal Data Processing Policy"
                  )[0] || "I accept the conditions set forth in the "
                : traducciones?.contacto?.condiciones?.split(
                    "Política de tratamiento de datos personales"
                  )[0] || "Acepto las condiciones establecidas en la "}
              <a
                href="#/"
                onClick={(e) => {
                  e.preventDefault();
                  const nuevaVentana = window.open();
                  if (nuevaVentana && politicas) {
                    nuevaVentana.document.write(
                      `<embed src="${politicas}" width="100%" height="100%" type="application/pdf">`
                    );
                  }
                }}
              >
                {traducciones?.contacto?.condiciones?.includes("Policy")
                  ? "Personal Data Processing Policy"
                  : "Política de tratamiento de datos personales"}
              </a>
              .
            </span>
          </label>
        </div>
        <div className="col-12 text-center">
          <button type="submit" className="btn btn-primary">
            {traducciones.contacto ? traducciones.contacto.boton : "Enviar"}
          </button>
        </div>
      </form>
    </div>
  );
}